import { forwardRef } from 'react';
import { emptyLongDash } from 'components/Inputs/DateTimeInput/helpers';
import { TextEllipsisWithTooltip } from 'components/Kizen/Table';
import SingleValue from './SingleValue';
import { StyledSelect } from './styles';
import { usePreReleaseFeatures } from 'hooks/usePreReleaseFeatures';

const InlineOwnerDropdown = forwardRef(
  ({ editable, value, onChange, components, ...rest }, ref) => {
    const preReleaseFeatures = usePreReleaseFeatures();
    return editable ? (
      <StyledSelect
        ref={ref}
        placeholder="Choose Team Member"
        margin
        variant="underline"
        collapse
        value={value}
        onChange={onChange}
        menuPortalTarget={document.body}
        components={{
          ...components,
          SingleValue: SingleValue,
        }}
        {...rest}
      />
    ) : (
      <TextEllipsisWithTooltip
        {...(value?.label &&
          preReleaseFeatures && {
            type: 'link',
            to: `/team-member/${value.id || value.value}/timeline`,
          })}
      >
        {value?.label || emptyLongDash}
      </TextEllipsisWithTooltip>
    );
  }
);

export default InlineOwnerDropdown;
